import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";
import { connect } from "unistore/preact";
import ThankYou from "components/summary/ThankYou";
import QuizSummary from "components/summary/QuizSummary";
import TextSummary from "components/summary/TextSummary";
import { actions } from "actions";
import { JotType, SummaryType } from "consts";
import { isNullOrUndefOrEmpty, onFocusRef, toObject } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/summary/Summary.scss';

const Summary = ({ finishData, config, results, getQuestions, focusable, jot, resultsDisabled = false }) => {
  const topFocusRef = useRef(null);
  const { summary } = toObject(finishData);
  const { portalUrl } = config;
  const summaryType = !isNullOrUndefOrEmpty(summary) ? summary.type : SummaryType.None;
  const noResults = results.length <= 0 || resultsDisabled;

  // componentDidMount
  useEffect(() => {
    setTopFocus();
  }, []);

  const setTopFocus = () => {
    focusable && onFocusRef(topFocusRef);
  };

  const restart = () => {
    // Track user restarting their session
    jot({
      space: "poll",
      type: JotType.EndRestart,
    });
    getQuestions({ reset: true });
  };

  const onPortalClick = () => {
    // Track user clicking on the portal link
    jot({
      space: "poll",
      type: JotType.EndUsersiteLink,
    });
  };

  return (
    <section className="csw-summary" ref={topFocusRef} tabIndex="-1">
      {noResults ? (
        <div className="csw-summary-detail">
          <ThankYou />
        </div>
      ) : (
        <div className="csw-summary-detail">
          {(summaryType === SummaryType.Quiz) & <QuizSummary summary={summary} />}
          {(summaryType === SummaryType.Text) & <TextSummary summary={summary} />}
        </div>
      )}

      <div className="csw-btns csw-stretch">
        {portalUrl ? (
          <a
            className="csw-btn csw-btn-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onPortalClick}
            href={portalUrl}
          >
            {i18n.t("BUTTON_GO")}
          </a>
        ) : (
          <button type="button" role="button" className="csw-btn csw-btn-primary csw-btn-restart" onClick={restart}>
            {i18n.t("BUTTON_ANSWER_MORE_QUESTIONS")}
          </button>
        )}
      </div>
    </section>
  );
};

Summary.propTypes /* remove-proptypes */ = {
  finishData: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  results: PropTypes.array.isRequired,
  getQuestions: PropTypes.func,
  focusable: PropTypes.bool,
  jot: PropTypes.func.isRequired,
  resultsDisabled: PropTypes.bool,
};

export default connect("finishData,config,results", actions)(Summary);
